import { useEffect, useState } from "react";
// react redux
import { useSelector } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import { Stack, Box } from "@mui/material";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    TableGrid,
    ThreeDotsLoader,
    CreateGift,
    CompensateTypeFilterBox,
} from "../../components";
// utils
import { errorAlert } from "../../utils/alerts/alerts";
import { getGiftsCols } from "../../utils/gridCols/giftsCols";
// global state  type
import { type ReduxUserReducerState } from "../../types/global";
import GiftTypeFilterBox from "../../components/filter/GiftTypeFilterBox";
const Gifts = () => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const { page, setPage } = usePageParams();
    const [gifts, setGifts] = useState([]);
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(24);
    const [totalItems, setTotalItems] = useState(10);
    const [loading, setLoading] = useState(true);
    const [filterValues, setFilterValues] = useState({
        compensate_type: "",
        gift_type_id: "",
    });
    // get all gifts
    const fetchGifts = () => {
        setLoading(true);
        // Build filters string dynamically
        const filtersArray = [];

        if (filterValues.compensate_type)
            filtersArray.push(`compensate_type:${filterValues.compensate_type}`);

        if (filterValues.gift_type_id && filterValues.gift_type_id !== "all")
            filtersArray.push(`gift_type_id:${filterValues.gift_type_id}`);

        const filtersString = filtersArray.join(",");

        const endpoint = `/admin/gifts?page=${page}&paginate=${itemsPerPage}&sorts=${sortValue}&q=${searchValue}${filtersString ? `&filters=${filtersString}` : ""
            }`;
        EnhancedAxios(null, userToken)
            .get(
                endpoint
            )
            .then((res: AxiosResponse) => {
                setGifts(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    };

    useEffect(() => {
        fetchGifts();
    }, [page, sortValue, searchValue, filterValues]);
    return (
        <Stack gap="20px">
            <PageTitle title="ادراة الهدايا" />
            <CreateGift onGiftAdded={fetchGifts} />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                {/* <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                /> */}
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <GiftTypeFilterBox
                    value={filterValues.gift_type_id}
                    onChange={(value) => setFilterValues({ ...filterValues, gift_type_id: value })}
                />
                <CompensateTypeFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
            </Box>
            {loading ? (
                <ThreeDotsLoader />
            ) : gifts.length === 0 ? (
                <p className="center-text">لا يوجد هدايا لعرضهم</p>
            ) : (
                <TableGrid
                    rows={gifts}
                    cols={getGiftsCols(fetchGifts)}
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    currentPage={page}
                    setCurrentPage={setPage}
                />
            )}
        </Stack>
    );
};

export default Gifts;
